import { setRecoil } from "recoil-nexus";
import { socket } from "../index";
import { projectTypesState } from "../../atoms/service";

interface ListenReceiveProjectTypesPayload {
  projectTypes: string[];
}

const listenReceiveProjectTypes = () => {
  socket?.on('RECEIVE_PROJECT_TYPES', (payload: ListenReceiveProjectTypesPayload) => {
    setRecoil(projectTypesState, payload.projectTypes);
  });
}

export default listenReceiveProjectTypes;